import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import BloodGlucoseCharts from "../Charts/BloodGlucoseCharts";
import BloodPressureCharts from "../Charts/BloodPressureCharts";
import WeightCharts from "../Charts/WeightCharts";
import O2SaturationCharts from "../Charts/O2SaturationCharts";
import TemperatureCharts from "../Charts/TemperatureCharts";
import { useLocation } from "react-router-dom";
import DashServices from "../../services/DashServices";
import FullPageLoader from "../Loaders/FullPageLoader";
import _ from "lodash";
import StepsCharts from "../Charts/StepsCharts";

const PatientSelfMeasuresTable = () => {
  const location = useLocation();
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [defaultActiveKey, setDefaultActiveKey] = useState(null);
  const [isFrOn, setIsFrOn] = useState(false)
  const [modulesKeys, setModulesKeys] = useState({
    hipertension: null,
    diabetes: null,
    pesos: null,
    saturacionO2: null,
    temperatura: null,
    pasos: null,
  });


  useEffect(() => {
    if (location.state.subscriptions) {
      loadSubscription(location.state.subscriptions.map((i) => i.id));
    }
  }, [location.state.subscriptions]);

  const loadSubscription = async (ids) => {
    setLoading(true);
    try {
      const fetchPromises = ids.map((i) => DashServices.getSubscriptions(i));
      const res = await Promise.all(fetchPromises);
      const data = await Promise.all(
        res.map((r) => {
          if (r.status != 200) return;
          return r.data.subscription.modules;
        })
      );

      const o2Module = data[0].find(m => m.name === "SaturacionO2");
      if (o2Module) {
        const frSubmodule = o2Module.submodules?.some(submodule =>
          submodule.label === 'Frecuencia Respiratoria' && submodule.selected
        );
        setIsFrOn(frSubmodule)
      }

      // cargamos por defecto los módulos de la primer suscripción
      let newModules = data[0];

      // iteramos sobre las siguientes suscripciones para unir los módulos
      for (let i = 1; i < data.length; ++i) {
        const difference = _.unionBy(newModules, data[i], "name");
        newModules = difference;
      }
      // obtenemos solo los ids de los módulos
      const m = newModules.map((i) => i.module);
      // guardamos esos ids
      setModules(m);
      // guardamos como par clave-valor el nombre del módulo y el id
      const modulesObject = newModules.reduce((acc, item) => {
        acc[_.kebabCase(item.name)] = item.module;
        return acc;
      }, {});
      setModulesKeys(modulesObject);
      // como en los diferentes entornos los modulos tienen id diferentes
      // de alguna forma tenemos que indicar la posición de las pestañas
      const tabKeyOrder = [
        modulesObject.hipertension ? modulesObject.hipertension : null,
        modulesObject.diabetes ? modulesObject.diabetes : null,
        modulesObject.pesos ? modulesObject.pesos : null,
        modulesObject["saturacion-o-2"]
          ? modulesObject["saturacion-o-2"]
          : null,
        modulesObject.temperatura ? modulesObject.temperatura : null,
        modulesObject.pasos ? modulesObject.pasos : null,
      ];
      // buscamos el primer valor de la variable tabKeyOrder que esté entre los módulos cargados en las suscripciones
      let selected = null;
      tabKeyOrder.forEach((i) => {
        const index = m.includes(i);
        if (index && selected == null) {
          selected = i;
        }
      });
      setDefaultActiveKey(selected);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const items = [
    {
      label: "Presión arterial",
      key:
        modulesKeys.hipertension != null
          ? modulesKeys.hipertension.toString()
          : "hipertension",
      disabled: !modules.includes(modulesKeys.hipertension),
      children: <BloodPressureCharts />,
    },
    {
      label: "Glucemia",
      key:
        modulesKeys.diabetes != null
          ? modulesKeys.diabetes.toString()
          : "diabetes",
      disabled: !modules.includes(modulesKeys.diabetes),
      children: <BloodGlucoseCharts />,
    },
    {
      label: "Peso",
      key: modulesKeys.pesos != null ? modulesKeys.pesos.toString() : "pesos",
      disabled: !modules.includes(modulesKeys.pesos),
      children: <WeightCharts />,
    },
    {
      label: "Saturación",
      key:
        modulesKeys["saturacion-o-2"] != null
          ? modulesKeys["saturacion-o-2"].toString()
          : "saturacion02",
      disabled: !modules.includes(modulesKeys["saturacion-o-2"]),
      children: <O2SaturationCharts isFrOn={isFrOn} />,
    },
    {
      label: "Temperatura",
      key:
        modulesKeys.temperatura != null
          ? modulesKeys.temperatura.toString()
          : "temperatura",
      disabled: !modules.includes(modulesKeys.temperatura),
      children: <TemperatureCharts />,
    },
    {
      label: "Pasos",
      key: modulesKeys.pasos != null ? modulesKeys.pasos.toString() : "pasos",
      disabled: !modules.includes(modulesKeys.pasos),
      children: <StepsCharts />,
    },
  ];
  return (
    <>
      {!loading && defaultActiveKey != null && (
        <Tabs
          defaultActiveKey={defaultActiveKey.toString()}
          style={{ maxWidth: "100%", borderwidth: 1, borderColor: "black" }}
          items={items}
        />
      )}
      {loading && <FullPageLoader />}
    </>
  );
};

export default PatientSelfMeasuresTable;
